import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Article } from '../data/articles';
interface NewsCardProps {
  article: Article;
  featured?: boolean;
}
export function NewsCard({
  article,
  featured = false
}: NewsCardProps) {
  return <article className={`bg-white border border-slate-200 overflow-hidden ${featured ? 'md:grid md:grid-cols-2 shadow-xl rounded-xl' : 'rounded-lg'}`} data-id="element-248" data-mp="20htw1nplxywo">
      <Link to={`/news/${article.slug}`} className={`block overflow-hidden ${featured ? 'min-h-[300px]' : 'h-48'}`} aria-label={`Read ${article.title}`} data-id="element-249" data-mp="12vwatijuffh1">
        <img src={article.image} alt="" className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-250" data-mp="1crg0hn7tdhxc" />
      </Link>

      <div className={featured ? 'p-8 md:p-10 flex flex-col justify-center' : 'p-6'} data-id="element-251" data-mp="2o6cvddqoj1cm">
        <p className="text-sm text-pac-gold font-bold uppercase tracking-wider mb-3" data-id="element-252" data-mp="2t4xx5hlkxt36">
          {article.category} <span className="text-slate-400 mx-1" data-id="element-253" data-mp="12rd2h2kpg7v8">·</span>{' '}
          {article.date}
        </p>
        <h2 className={`font-serif font-bold text-pac-navy mb-3 ${featured ? 'text-3xl md:text-4xl' : 'text-2xl'}`} data-id="element-254" data-mp="xturl6n4nikl">
          <Link to={`/news/${article.slug}`} className="hover:text-pac-blue transition-colors" data-id="element-255" data-mp="osdbho9pzgvw">
            {article.title}
          </Link>
        </h2>
        <p className="text-slate-600 leading-relaxed mb-5" data-id="element-256" data-mp="jv4x7yrozwzx">{article.excerpt}</p>
        <Link to={`/news/${article.slug}`} className="inline-flex items-center gap-2 text-pac-red font-bold hover:text-red-800 transition-colors w-fit focus:outline-none focus:ring-2 focus:ring-pac-gold focus:ring-offset-2 rounded" data-id="element-257" data-mp="f18wwpnyhy1l">
          Read the update <ArrowRight className="h-4 w-4" data-id="element-258" data-mp="11hhqllpebm0" />
        </Link>
      </div>
    </article>;
}